import {
  FRONT_WARNING,
  PROD_BY_HELP_DATABASE,
  PROD_MODE,
} from '@app/constants';
import type { NNotificationProvider } from '@app/providers/NotificationProvider/NotificationProvider.types';
import type { NAccessRights, NAuth } from '@app/types';
import { defineDeployingMode } from '@app/utils';

// См. подр. блок-схему алгоритма в описании задачи по ссылке ниже, а также в юнит-тестах:
// https://tree.taiga.io/project/evgenysobolev-byhelp/us/4949?milestone=435651

type HasRightsToOrgsCrmModule = (
  clientHost: string,
  database: NAuth.UserPrint['database'],
  accessRights: NAccessRights.ModelAccessRights | null,
  showNotification: NNotificationProvider.ShowNotificationType,
  withMainAlgorithm?: boolean
) => boolean;

export const hasRightsToOrgsCrmModule: HasRightsToOrgsCrmModule = (
  clientHost,
  database,
  accessRights,
  showNotification,
  withMainAlgorithm = true
): boolean => {
  if (!accessRights) {
    showNotification(
      'Информация об имеющихся правах не найдена',
      FRONT_WARNING
    );

    return false;
  }

  const {
    IsAdmin: isAdmin,
    Organizations: { IsOn: hasUserRightToOrgsModule },
  } = accessRights;

  const isProd = defineDeployingMode(clientHost) === PROD_MODE;
  const isBusinessSolutionOrg = database === PROD_BY_HELP_DATABASE;

  if (isProd) {
    if (!isBusinessSolutionOrg) {
      return false;
    }
  }

  if (withMainAlgorithm) {
    if (isAdmin) {
      return true;
    }

    if (!hasUserRightToOrgsModule) {
      return false;
    }
  }

  return true;
};
